import { createSelector } from "reselect";

const selectApp = (state) => state.app;

const selectAppUser = () => createSelector(selectApp, (appState) => appState.user);
const selectDeviceTypes = () => createSelector(selectApp, (appState) => appState.deviceTypes);
const selectIoTypes = () => createSelector(selectApp, (appState) => appState.ioTypes);
const selectIoActionsTypes = () => createSelector(selectApp, (appState) => appState.ioActionTypes);
const selectAppModulesAccess = () => createSelector(selectApp, (appState) => appState.appModulesAccess);
const selectAppFieldsAccess = () => createSelector(selectApp, (appState) => appState.appFieldsAccess);
const selectApplicationSettings = () => createSelector(selectApp, (appState) => appState.applicationSettings);
const selectIsLoading = () => createSelector(selectApp, (appState) => appState.loading);
const selectIsReady = () => createSelector(selectApp, (appState) => appState.ready);


export {
    selectAppUser,
    selectDeviceTypes,
    selectIoTypes,
    selectIoActionsTypes,
    selectAppModulesAccess,
    selectAppFieldsAccess,
    selectApplicationSettings,
    selectIsLoading,
    selectIsReady
}


